<template lang="pug">
  .resource-view-wrapper(:class="'context-' + context")
    include Benefits.pug
</template>

<script>
import _ from 'underscore'
import PrivateRouterLink from '@/directives/PrivateRouterLink'
import Banner from '@/components/Banner'
import { mapState } from 'vuex';

export default {
  name: 'Benefits',
  props: [],
  components: {
    PrivateRouterLink,
    Banner,
  },
  computed: mapState([
    "context",
  ]),
  data() {
    return {}
  },
  created() {},
}
</script>

<style lang="scss">
@import './../../variables';
@import './../../variables_colreps';

.resource-view-wrapper {
  @import '../dashboard/Dashboard';
  @import '../dashboard/DashboardIndex';
  @import 'Benefits';
}

</style>



// WEBPACK FOOTER //
// src/components/benefits/Benefits.vue